export const INTERNAL_CHAT_EVENT = 'bluezap:internal-chat-event';
export const CHAT_STATE_REFRESH_EVENT = 'bluezap:chat-state-refresh';

export function dispatchInternalChatEvent(detail) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(INTERNAL_CHAT_EVENT, {
      detail,
    })
  );
}

export function dispatchChatStateRefreshEvent(detail) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(CHAT_STATE_REFRESH_EVENT, {
      detail,
    })
  );
}
